import { useEffect } from "react";
import { useSelector } from "react-redux";
import { reportPlatformRedirect } from "../utils/analytics/reportPlatformRedirect";
import postMessageBridgeTypes from "../enums/postMessageBridgeTypes";

/**
 * Listens for postMessage from DelayNavigatePage (same origin) and sends platform_redirect from this document.
 */
export function usePlatformRedirectOpenerBridge() {

    const providersHost = useSelector(state => state.uiData.providersHost);

    useEffect(() => {
        const platformRedirectAnalyticsMessageHandler = (event) => {
            if (event.origin !== window.location.origin)
                return;
            if (!event.data || event.data.type !== postMessageBridgeTypes.PLATFORM_REDIRECT)
                return;
            const link = event.data.link;
            if (typeof link !== "string" || !link.startsWith("http"))
                return;
            reportPlatformRedirect(link, providersHost, event.data.ga);
        };
        window.addEventListener("message", platformRedirectAnalyticsMessageHandler);
        return () => window.removeEventListener("message", platformRedirectAnalyticsMessageHandler);
    }, [providersHost]);
}

export default usePlatformRedirectOpenerBridge;
